import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { loaderItems } from "../../../../../../../../shared/src/lib/utils/common";

@Component({
  selector: "app-nhr-loader",
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./nhr-loader.component.html",
  styleUrl: "./nhr-loader.component.scss",
})
export class NhrLoaderComponent {
  @Input() show: boolean | null = false;
  protected readonly loaderItems = loaderItems;
}
